import { htmlEncode } from '@/utils/htmlUtils';

export const getIdsOfItems = (hiredProduct, productType) => {
  const idsArray = [];
  let lastPhoneNumberOfCurrentBundle = null;
  const productHasPhone =
    (productType >= 0 && productType < 3) || productType === 4;
  const productHasPhone1 = hiredProduct.phone !== null;
  if (productHasPhone && productHasPhone1) {
    const { linesPhone } = hiredProduct.phone;
    linesPhone.map((currentLines) => {
      const kindProduct = 'phone';
      const res = {
        kindProduct,
        number: currentLines.number,
        productId: currentLines.productId,
      };
      lastPhoneNumberOfCurrentBundle = currentLines.number;
      idsArray.push(res);
      return null;
    });
  }
  const productHasMobile =
    productType === 0 || productType === 3 || productType === 5;
  const productHasMobile1 = hiredProduct.mobile !== null;
  if (productHasMobile && productHasMobile1) {
    const { linesMobile } = hiredProduct.mobile;
    linesMobile.map((currentLines) => {
      const kindProduct = 'mobile';
      const res = {
        kindProduct,
        number: currentLines.number,
        productId: currentLines.productId,
      };
      idsArray.push(res);
      return null;
    });
  }
  const productHasInternet =
    productType === 0 || productType === 1 || productType === 2;
  const productHasInternet1 = hiredProduct.internet !== null;
  if (productHasInternet && productHasInternet1) {
    const kindProduct = 'internet';
    const res = {
      kindProduct,
      productId: hiredProduct.internet.productId,
    };
    if (lastPhoneNumberOfCurrentBundle) {
      res.number = lastPhoneNumberOfCurrentBundle;
    }
    idsArray.push(res);
  }
  const productHasTv = productType === 0 || productType === 1;
  const productHasTv1 = hiredProduct.tv !== null;
  if (productHasTv && productHasTv1) {
    const kindProduct = 'tv';
    const res = {
      kindProduct,
      productId: hiredProduct.tv.productId,
    };
    if (lastPhoneNumberOfCurrentBundle) {
      res.number = lastPhoneNumberOfCurrentBundle;
    }
    idsArray.push(res);
  }
  return idsArray;
};

export const getAllDataItems = (hiredProduct) => {
  const idsArray = getIdsOfItems(hiredProduct, hiredProduct.productType);
  return idsArray;
};

export const normalizeClientProduct = (myProducts) => {
  let myProductsNew = []; // Array to store normalized products

  // Check if the 'productosContratados' property exists in 'myProducts'
  if (myProducts?.productosContratados) {
    // Iterate through each product in 'productosContratados' array
    myProducts.productosContratados.forEach((product) => {
      // Check if the product type is one of the specified types (0, 1, 2, 3, 4, 5, 9)
      const types = [0, 1, 2, 3, 4, 5, 9];
      if (types.includes(product.productType)) {
        const newProductObj = product; // Create a new object to hold the normalized product

        // Normalize the 'name' property if it exists
        if (newProductObj.name) {
          newProductObj.name = htmlEncode(newProductObj.name);
        }

        // Normalize the 'description' property if it exists
        if (newProductObj.description) {
          newProductObj.description = htmlEncode(newProductObj.description);
        }

        let newLinesMobile = null;

        // Check if the 'mobile' property and 'linesMobile' array exist in the product
        if (product.mobile && product.mobile.linesMobile) {
          // Map over the 'linesMobile' array and create a new array of normalized items
          newLinesMobile = product.mobile.linesMobile.map((itemMobile) => {
            const newItemLineMobile = itemMobile;
            newItemLineMobile.main = false;
            return newItemLineMobile;
          });
        }

        // Assign the normalized 'linesMobile' array to the new product object
        if (newLinesMobile) {
          newProductObj.mobile.linesMobile = newLinesMobile;
        }

        // Get additional data items (ids) associated with the product
        const ids2Add = getAllDataItems(product);

        // Create a new product object with the normalized properties and additional ids
        const newProduct = {
          ...newProductObj,
          childProductId: ids2Add,
        };

        // Add the new normalized product to the 'myProductsNew' array
        myProductsNew.push(newProduct);
      }
    });
  }

  // Sort the 'myProductsNew' array based on product type in ascending order
  myProductsNew = myProductsNew.sort(function sort(a, b) {
    return a.productType - b.productType;
  });

  // Return the normalized products array
  return myProductsNew;
};

export function normalizeFusionInfoToLocalStore(input) {
  const mapping = {
    FUSION_AV: 1,
    FUSION_MV: 2,
    FUSION_BV: 3,
  };

  return mapping[input] || input;
}

export function normalizeFusionInfoToStore(input) {
  const mapping = {
    FUSION_AV: 'av',
    FUSION_MV: 'mv',
    FUSION_BV: 'bv',
    1: 'av',
    2: 'mv',
    3: 'bv',
  };
  return mapping[input] || input;
}